import React from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import RelativeContainerOrg from "../RelativeContainerOrg";

// eslint-disable-next-line no-shadow
export var FlexVerticalPosition = /*#__PURE__*/function (FlexVerticalPosition) {
  FlexVerticalPosition["TOP"] = "start";
  FlexVerticalPosition["CENTER"] = "center";
  FlexVerticalPosition["BOTTOM"] = "end";
  return FlexVerticalPosition;
}({});

// eslint-disable-next-line no-shadow
export var FlexHorizontalPosition = /*#__PURE__*/function (FlexHorizontalPosition) {
  FlexHorizontalPosition["LEFT"] = "left";
  FlexHorizontalPosition["CENTER"] = "center";
  FlexHorizontalPosition["RIGHT"] = "right";
  return FlexHorizontalPosition;
}({});
var StyledImageWrapperOrg = styled.div.withConfig({
  componentId: "sc-1m5fytr-0"
})(function (_ref) {
  var $hasTopScaledImage = _ref.$hasTopScaledImage,
    $hasImageBox = _ref.$hasImageBox,
    $horizontalPosition = _ref.$horizontalPosition,
    $verticalPosition = _ref.$verticalPosition;
  return css(["height:100%;display:flex;", " ", " ", ""], $horizontalPosition ? css(["justify-content:", ";"], $horizontalPosition) : null, $verticalPosition ? css(["align-items:", ";"], $verticalPosition) : null, $hasTopScaledImage && breakpoint("large") ? css(["", "{width:100%;height:100%;img{object-fit:cover;width:100%;height:100%;}", "}"], RelativeContainerOrg, $hasImageBox ? css(["& > div:last-child{position:absolute;}"]) : null) : null);
});
function ImageWrapperOrg(_ref2) {
  var hasTopScaledImage = _ref2.hasTopScaledImage,
    hasImageBox = _ref2.hasImageBox,
    horizontalPosition = _ref2.horizontalPosition,
    verticalPosition = _ref2.verticalPosition,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(StyledImageWrapperOrg, {
    $hasTopScaledImage: hasTopScaledImage,
    $hasImageBox: hasImageBox,
    $horizontalPosition: horizontalPosition,
    $verticalPosition: verticalPosition
  }, /*#__PURE__*/React.createElement(RelativeContainerOrg, null, children));
}
export default ImageWrapperOrg;